import { setDefaultFiltersBeforeEnter } from 'asteroid'

export default [
  {
    name: 'ActiveOffersListLayout',
    path: 'active-offers',
    component: () => import('pages/active-offers/_layouts/ActiveOffersListLayout.vue'),
    redirect: { name: 'ActiveOffersCustomersForm' },
    children: [
      {
        name: 'ActiveOffersCustomersForm',
        path: 'customers',
        beforeEnter: setDefaultFiltersBeforeEnter,
        component: () => import('src/pages/active-offers/list/tabs/customers/ActiveOffersCustomersForm.vue'),
        meta: { slug: 'customers' }
      },
      {
        path: 'dashboard',
        name: 'ActiveOffersDashboardList',
        beforeEnter: setDefaultFiltersBeforeEnter,
        component: () => import('pages/active-offers/list/tabs/dashboard-list/ActiveOffersDashboardList.vue'),
        meta: { slug: 'dashboard' }
      },
      {
        path: 'campaigns',
        name: 'ActiveOffersCampaignsList',
        beforeEnter: setDefaultFiltersBeforeEnter,
        component: () => import('pages/active-offers/list/tabs/campaigns/ActiveOffersCampaignsList.vue'),
        meta: { slug: 'campaigns' }
      }
    ]
  },
  {
    path: 'active-offers/campaigns/:id',
    name: 'ActiveOffersCampaignsSingle',
    component: () => import('pages/active-offers/list/tabs/campaigns/single/ActiveOffersCampaignsSingle.vue')
  }
]
